import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'ebb-portal-dialog-confirm-iv-delete',
    templateUrl: './dialog-confirm-iv-delete.component.html',
    styles: [],
    standalone: false
})
export class DialogConfirmIvDeleteComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmIvDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onClickYes(): void {
    this.dialogRef.close(true);
  }

  onClickNo(): void {
    this.dialogRef.close(false);
  }

}
